import Axios from 'axios';
import { API_FILTER } from '../../api/api';

export const getMerk = async () => {
  try {
    let res = await Axios.get(API_FILTER.filter + 'merk');
    res.data.data.unshift({ value: '', label: 'Pilih Merek' });
    return res.data.data;
  } catch (error) { }
};

export const getSeri = async (merk) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `seri?merk=${merk}`);
    res.data.data.unshift({ value: '', label: 'Pilih Seri' });
    return res.data.data;
  } catch (error) { }
};

export const getTipe = async (merk, seri) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `tipe?merk=${merk}&seri=${seri}`);
    res.data.data.unshift({ value: '', label: 'Pilih Tipe' });
    return res.data.data;
  } catch (error) { }
};

export const getSilinder = async (merk, seri, tipe) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `silinder?merk=${merk}&seri=${seri}&tipe=${tipe}`);
    res.data.data.unshift({ value: '', label: 'Pilih Silinder' });
    return res.data.data;
  } catch (error) { }
};

export const getTahun = async (merk, seri, tipe, silinder) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `tahun?merk=${merk}&seri=${seri}&tipe=${tipe}&silinder=${silinder}`);
    res.data.data.unshift({ value: '', label: 'Pilih Tahun' });
    return res.data.data;
  } catch (error) { }
};

export const getKota = async (merk, seri, tipe, silinder, tahun, sampai_tahun) => {
  try {
    let res = await Axios.get(
      API_FILTER.filter +
      `location?merk=${merk}&seri=${seri}&tipe=${tipe}&silinder=${silinder}&tahun=${tahun}&sampai_tahun=${sampai_tahun}`
    );
    res.data.data.unshift({ value: '', label: 'Pilih Kota' });
    return res.data.data;
  } catch (error) { }
};

export const getTransmisi = async (merk, seri, tipe, silinder, tahun, sampai_tahun, lokasi) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `transmisi?merk=${merk}&seri=${seri}&tipe=${tipe}&silinder=${silinder}&tahun=${tahun}&sampai_tahun=${sampai_tahun}&lokasi=${lokasi}`);
    res.data.data.unshift({ value: '', label: 'Pilih Transmisi' });
    return res.data.data;
  } catch (error) { }
};
export const getModel = async (merk, seri, tipe, silinder, kota) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `model?merk=TOYOTA&lokasi=JAKARTA`);
    res.data.data.unshift({ value: 'label', label: 'Pilih Model' });
    return res.data.data;
  } catch (error) { }
};

export const getGrades = async (merk, kota) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `grade?merk=${merk}&lokasi=${kota}`);
    res.data.data.unshift({ value: 'label', label: 'Pilih Grade' });
    return res.data.data;
  } catch (error) { }
};

export const getGrade = async (merk, seri, tipe, silinder, kota, model) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `grade?merk=TOYOTA&lokasi=JAKARTA`);
    res.data.data.unshift({ value: 'label', label: 'Pilih Jenis' });
    return res.data.data;
  } catch (error) { }
};
export const getWarna = async (merk, seri, tipe, silinder, kota, model, grade, transmisi, tahun) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `color?merk=TOYOTA&lokasi=JAKARTA`);
    res.data.data.unshift({ value: 'label', label: 'Pilih Warna' });
    return res.data.data;
  } catch (error) { }
};

export const getKepemilikan = async (merk, seri, tipe, silinder, periode, kota, transmisi, tahun) => {
  try {
    let res = await Axios.get(
      API_FILTER.filter +
      `kepemilikan?merk=${merk}&periode=${periode}&seri=${seri}&silinder=${silinder}&tipe=${tipe}&tahun=${tahun}&transmisi=${transmisi}&lokasi=${kota}`
    );
    res.data.data.unshift({ value: 'label', label: 'Pilih Kepemilikan' });
    return res.data.data;
  } catch (error) { }
};

export const getNopolisi = async (merk, kota) => {
  try {
    let res = await Axios.get(API_FILTER.filter + `nopolisi?merk=${merk}&lokasi=${kota}`);
    res.data.data.unshift({ value: 'label', label: 'Pilih Plat Nomor' });
    return res.data.data;
  } catch (error) { }
};

export const getStnk = async (merk, seri, tipe, silinder, periode, kota, grade, transmisi, kepemilikan) => {
  try {
    let res = await Axios.get(
      API_FILTER.filter +
      `stnk?merk=${merk}&periode=${periode}&seri=${seri}&tipe=${tipe}&silinder=${silinder}&lokasi=${kota}&grade=${grade}&transmisi=${transmisi}&typeKepemilikan=${kepemilikan}`
    );
    res.data.data.unshift({ value: 'label', label: 'Pilih STNK' });
    return res.data.data;
  } catch (error) { }
};

export const getKotaCekHarga = async (merk, seri, tipe, silinder, tahun, transmisi) => {
  try {
    let res = await Axios.get(
      API_FILTER.filter +
      `location?merk=${merk}&seri=${seri}&tipe=${tipe}&silinder=${silinder}&tahun=${tahun}&transmisi=${transmisi}`
    );
    res.data.data.unshift({ value: 'label', label: 'Pilih Kota' });
    return res.data.data;
  } catch (error) { }
};

export const getTransmisiCekHarga = async (merk, seri, tipe, silinder, tahun) => {
  try {
    let res = await Axios.get(
      API_FILTER.filter + `transmisi?merk=${merk}&seri=${seri}&tipe=${tipe}&silinder=${silinder}&tahun=${tahun}`
    );
    res.data.data.unshift({ value: 'label', label: 'Pilih Transmisi' });
    return res.data.data;
  } catch (error) { }
};
